import React, { useEffect, useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, TextInput } from 'react-native';
import { FONT_STYLE } from '../../dataSchema/const';

const MultipleChoiceQuestion = ({ question, selectHandler, defaultAnswer = null, isCustom = false }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isOther, setOtherAnswer] = useState(false);
  const [other, setOtherText] = useState('')

  const handleToggleSelect = (choice) => {
    let choices: string[] = [];
    if (selectedOptions.includes(choice.label)) {
      choices = selectedOptions.filter((option) => option !== choice.label)
    } else {
      choices = [...selectedOptions, choice.label || choice]
    }
    setSelectedOptions(choices);
    if (selectHandler) {
      selectHandler(choices);
    }
  };

  useEffect(() => {
    if (defaultAnswer && defaultAnswer.values) {
      setSelectedOptions(defaultAnswer.values);
      let strings: string[] = [];
      for (let e of question.choices)
        strings.push(e.label);
      let otherStr = defaultAnswer.values.filter(item => !strings.includes(item)).concat(strings.filter(item => !defaultAnswer.values.includes(item)))[0];
      if (otherStr && otherStr.length) {
        setOtherText(otherStr);
        setOtherAnswer(true);
      }
    }
  }, [])

  const onChangeText = (text) => {
    setOtherText(text);
  }

  const ClearText = () => {
    setOtherText('');
  }

  return (
    <View style={styles.container}>
      {question.choices.map((choice, index) => (
        <TouchableOpacity
          key={index}
          style={styles.option}
          onPress={() => handleToggleSelect(choice)}
        >
          <View style={[styles.checkbox, { borderColor: selectedOptions.includes(choice.label) ? '#F65D79' : '#000000' }]}>
            {selectedOptions.includes(choice.label) && <View style={styles.checkboxInner} />}
          </View>
          <Text style={styles.optionText}>{choice.label}</Text>
        </TouchableOpacity>
      ))}
      {
        isCustom ? (
          <View
            style={styles.option}
          >
            <TouchableOpacity onPress={() => {
              if (!isOther) {
                ClearText();
              }
              setOtherAnswer(!isOther)
            }
            }>
              <View style={[styles.checkbox, { borderColor: isOther ? '#F65D79' : '#000000' }]}>
                {
                  !isOther ? null : (<View style={styles.checkboxInner}></View>)
                }
              </View>
            </TouchableOpacity>
            <TextInput style={styles.inputCustomeChoice}
              value={other}
              onChangeText={(text) => {
                onChangeText(text)
              }}

              onBlur={() => {
                if (isOther) {
                  handleToggleSelect(other);
                }
              }}

              onFocus={() => {
                setOtherText('');
                setOtherAnswer(true);
              }}
              autoFocus={false}
              placeholder='Nếu chọn "Khác", vui lòng ghi rõ'
              placeholderTextColor={'#666666'}
              maxLength={255}
            ></TextInput>
          </View>
        ) : null
      }
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginVertical: 16,
  },
  option: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 10
  },
  checkbox: {
    height: 18,
    width: 18,
    borderRadius: 2,
    borderWidth: 2,
    marginRight: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  checkboxInner: {
    height: 8,
    width: 8,
    borderRadius: 2,
    backgroundColor: '#F65D79',
  },
  optionText: {
    fontSize: 14,
    color: '#444444',
    fontFamily: FONT_STYLE.MEDIUM
  },
  inputCustomeChoice: {
    height: 56,
    width: '100%',
    padding: 10,
    borderRadius: 10,
    borderColor: '#444444',
    borderWidth: 1,
    textAlignVertical: 'center',
    fontFamily: FONT_STYLE.MEDIUM,
    fontSize: 14
  }
});

export default MultipleChoiceQuestion;
